import { render, staticRenderFns } from "./SystemItemActivity.vue?vue&type=template&id=1bc1d79d&scoped=true&"
import script from "./SystemItemActivity.vue?vue&type=script&lang=js&"
export * from "./SystemItemActivity.vue?vue&type=script&lang=js&"
import style0 from "./SystemItemActivity.vue?vue&type=style&index=0&id=1bc1d79d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1d79d",
  null
  
)

export default component.exports